export default __webpack_public_path__ + "071f5e35ddf1c9ad403ff9e28e8bf37c.webp";